import { regex } from "@/constant/config";
import commonActionHandle from "@/commonActionHandle";
import { CHANGE_PASSWORD_RESULT } from "@/constant/user";

// Api  
import api from '@/api/baseApi';

// Extend
import base from '@/scripts/base';

// Constant
import { SETTINGS_USER_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";

export default {

  extends: base,

  data() {
    var validatePassword = (rule, value, callback) => {
      if (value.match(regex.password)) {        
        if (!value.match(regex.passwordAtLeastUppercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastUppercaseChar));
        if (!value.match(regex.passwordAtLeastLowercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastLowercaseChar));
        if (!value.match(regex.passwordAtLeastNumber)) return callback(new Error(this.$lang.register.passwordAtLeastNumber));
        if (!value.match(regex.passwordAtLeastSpecialChar)) return callback(new Error(this.$lang.register.passwordAtLeastSpecialChar));
        if (!value.match(regex.passwordAtNoSpace)) return callback(new Error(this.$lang.register.passwordAtNoSpace));
        return callback();
      } else {
        return callback(new Error(this.$lang.register.validationTypePassword));
      }
    };
    var validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.changePasswordForm.newPassword) {
        return callback(new Error(this.$lang.register.validationConfirmPasswordMatch));
      } else {
        if (value.match(regex.password)) {
          if (!value.match(regex.passwordAtLeastUppercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastUppercaseChar));
          if (!value.match(regex.passwordAtLeastLowercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastLowercaseChar));
          if (!value.match(regex.passwordAtLeastNumber)) return callback(new Error(this.$lang.register.passwordAtLeastNumber));
          if (!value.match(regex.passwordAtLeastSpecialChar)) return callback(new Error(this.$lang.register.passwordAtLeastSpecialChar));
          if (!value.match(regex.passwordAtNoSpace)) return callback(new Error(this.$lang.register.passwordAtNoSpace));
          return callback();
        } else {
          return callback(new Error(this.$lang.register.validationTypePassword));
        }
      }
    };
    return {
      delayNotification: 1000,
      value: "",
      isLoading: false,
      changePasswordForm: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
        deviceInformation: null,
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: this.$lang.changePassword.validationRequiredPassword,
            trigger: "blur"
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$lang.register.validationRequiredPassword,
            trigger: "blur"
          },
          {
            min: 6,
            message: this.$lang.register.validationMinPassword,
            trigger: ["blur", "change"]
          },
          {
            max: 50,
            message: this.$lang.register.validationMaxPassword,
            trigger: ["blur", "change"]
          },
          { validator: validatePassword, trigger: "blur" }
        ],

        confirmPassword: [
          {
            required: true,
            message: this.$lang.register.validationRequiredPassword,
            trigger: "blur"
          },
          { validator: validateConfirmPassword, trigger: "blur" }
        ],
      }
    };
  },

  methods: {

    // Submit form change password
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.feedStatusLoading(API_CALL_STATUS.LOADING);
          this.changePasswordForm.deviceInformation = JSON.stringify(this.getInformationClient());
          api.baseRequest(SETTINGS_USER_API.CHANGE_PASSWORD, this.changePasswordForm)
            .then((res) => {
              switch (res.errorCode) {
                case CHANGE_PASSWORD_RESULT.SUCCESS:
                  commonActionHandle.showCustomSuccess(
                    'Successful change !',
                    'Your password has been changed successfully',
                    () => {
                      this.changePasswordForm = {
                        oldPassword: null,
                        newPassword: null,
                        confirmPassword: null,
                        deviceInformation: null,
                      }
                    },
                    () => { },
                    null,
                    null,
                    false,
                  );
                  break;
                case CHANGE_PASSWORD_RESULT.OLD_PASSWORD_INVALID:
                  commonActionHandle.showCustomWarning(
                    'Change password failed',
                    'Current password is incorrect',
                    () => {
                      this.changePasswordForm = {
                        oldPassword: null,
                        newPassword: null,
                        confirmPassword: null,
                        deviceInformation: null,
                      }
                    },
                    () => { },
                    null,
                    null,
                    false,
                  );
                  break;
				  
                case CHANGE_PASSWORD_RESULT.NEW_PASSWORD_INVALID:
                  commonActionHandle.showCustomWarning(
                    'Change password failed',
                    res.message,
                    () => {
                      this.changePasswordForm = {
                        oldPassword: null,
                        newPassword: null,
                        confirmPassword: null,
                        deviceInformation: null,
                      }
                    },
                    () => { },
                    null,
                    null,
                    false,
                  );
                  break;
              }
              this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
            })
            .catch(error => {
              this.processCatchApiRequest(error, "Change password failed ...")
            });
        } else {
          return false;
        }
      });
    },
  }
};